import { render, staticRenderFns } from "./MyAddress.vue?vue&type=template&id=f94495da&scoped=true&"
import script from "./MyAddress.vue?vue&type=script&lang=js&"
export * from "./MyAddress.vue?vue&type=script&lang=js&"
import style0 from "./MyAddress.vue?vue&type=style&index=0&id=f94495da&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94495da",
  null
  
)

export default component.exports